export default __webpack_public_path__ + "static/media/ico-phone-settings.f7958a4d.svg";